import React from 'react';
import { MISSION_VISION } from '../data/mock';
import { Target, Eye, CheckCircle2, Sparkles } from 'lucide-react';
import PageHero from '../components/PageHero';

export default function MissionVision() {
  return (
    <div>
      <PageHero
        eyebrow={MISSION_VISION.hero.eyebrow}
        title={MISSION_VISION.hero.title}
        subtitle={MISSION_VISION.hero.subtitle}
      />

      <section className="py-20 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-8 lg:gap-10">
          <div className="rounded-3xl border border-orange-100 bg-[#FFF9F1] p-8 lg:p-12 relative overflow-hidden">
            <div className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-[radial-gradient(closest-side,#FFD5B4,transparent_70%)]" />
            <div className="relative">
              <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-[#FFB27A] to-[#E85A18] flex items-center justify-center">
                <Target className="h-6 w-6 text-white" />
              </div>
              <h2
                className="mt-6 text-[32px] lg:text-[40px] font-semibold text-[#0F1B2D] tracking-tight"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {MISSION_VISION.mission.heading}
              </h2>
              <p className="mt-4 text-[15.5px] leading-[1.75] text-slate-700">{MISSION_VISION.mission.body}</p>
              <ul className="mt-6 space-y-3">
                {MISSION_VISION.mission.points.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-[14.5px] text-slate-700">
                    <CheckCircle2 className="h-4.5 w-4.5 text-[#FF7A2E] mt-1 flex-shrink-0" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="rounded-3xl bg-[#0F1B2D] p-8 lg:p-12 relative overflow-hidden text-white">
            <div className="absolute -bottom-24 -left-16 w-72 h-72 rounded-full bg-[radial-gradient(closest-side,#FF7A2E,transparent_70%)] opacity-30" />
            <div className="relative">
              <div className="h-12 w-12 rounded-xl bg-white/10 border border-white/20 flex items-center justify-center">
                <Eye className="h-6 w-6 text-[#FFB27A]" />
              </div>
              <h2
                className="mt-6 text-[32px] lg:text-[40px] font-semibold tracking-tight"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {MISSION_VISION.vision.heading}
              </h2>
              <p className="mt-4 text-[15.5px] leading-[1.75] text-slate-300">{MISSION_VISION.vision.body}</p>
              <ul className="mt-6 space-y-3">
                {MISSION_VISION.vision.points.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-[14.5px] text-slate-200">
                    <Sparkles className="h-4.5 w-4.5 text-[#FFB27A] mt-1 flex-shrink-0" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-24 bg-[#FDF8F2]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-2xl mb-12">
            <span className="text-[12.5px] uppercase tracking-[0.22em] font-semibold text-[#E85A18]">Our Values</span>
            <h2
              className="mt-3 text-[32px] lg:text-[42px] leading-[1.1] tracking-tight text-[#0F1B2D] font-semibold"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              What we hold ourselves to.
            </h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {MISSION_VISION.values.map((v, i) => (
              <div
                key={v.title}
                className="rounded-2xl bg-white border border-orange-100/80 p-6 hover:shadow-[0_20px_50px_-25px_rgba(232,90,24,0.35)] transition-shadow duration-500"
              >
                <div className="text-[11px] font-mono tracking-widest text-[#E85A18]">0{i + 1}</div>
                <h3 className="mt-4 text-[18px] font-semibold text-[#0F1B2D]" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                  {v.title}
                </h3>
                <p className="mt-2 text-[14px] leading-[1.65] text-slate-600">{v.copy}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
